export interface FlagsmithConfig {
  environmentID: string;
  api: string;
}

declare global {
  interface Window {
    __ARIKSA_RUNTIME_CONFIG__?: {
      flagsmithUrl?: string;
      flagsmithEnvironmentId?: string;
    };
  }
}

const isIpv4Address = (hostname: string) =>
  /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

export const getFlagsmithEnvironmentId = (hostname: string) => {
  const normalizedHostname = hostname.split(':')[0].toLowerCase();

  if (
    !normalizedHostname ||
    normalizedHostname === 'localhost' ||
    isIpv4Address(normalizedHostname)
  ) {
    return '';
  }

  const hostnameParts = normalizedHostname.split('.').filter(Boolean);

  return hostnameParts.length >= 3 ? hostnameParts[0] : '';
};

export const getFlagsmithConfig = (): FlagsmithConfig => {
  const runtimeConfig =
    typeof window === 'undefined'
      ? undefined
      : window.__ARIKSA_RUNTIME_CONFIG__;
  // VITE_* overrides are intended for local Vite development. Deployed
  // containers should use the runtime FLAGSMITH_ENVIRONMENT_ID override.
  // @ts-ignore Vite exposes custom environment variables through import.meta.env.
  const localEnvironmentId = import.meta.env?.VITE_FLAGSMITH_ENVIRONMENT_ID?.toString().trim();
  // @ts-ignore Vite exposes custom environment variables through import.meta.env.
  const localApi = import.meta.env?.VITE_FLAGSMITH_API?.toString().trim();

  return {
    environmentID:
      runtimeConfig?.flagsmithEnvironmentId?.trim() ||
      localEnvironmentId ||
      getFlagsmithEnvironmentId(
        typeof window === 'undefined' ? '' : window.location.hostname,
      ),
    api: runtimeConfig?.flagsmithUrl?.trim() || localApi || '',
  };
};
